import React from "react";
import dayjs from "dayjs";
import Table from "../../../../common/element/Table";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const LearningFeedbackList = ({ sampleData, loading, onView }) => {
  return (
    <div className="border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Name</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Email Address</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Contact Number</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Company Name</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Submitted On</Th>
            <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Action</Th>
          </Tr>
        </THead>
        <TBody>
          {loading ? (
            <Tr>
              <Td colSpan={7} className="py-10 text-center">
                <ThreeDotBouncingLoader />
              </Td>
            </Tr>
          ) : sampleData.length > 0 ? (
            sampleData.map((item, index) => (
              <Tr key={item.id || index} className="text-start">
                <Td className="text-start">{String(index + 1).padStart(2, "0")}</Td>
                <Td className="text-start">{item.participant_name || "-"}</Td>
                <Td className="text-start">{item.email_address || item.email || "-"}</Td>
                <Td className="text-start">{item.contact_number || "-"}</Td>
                <Td className="text-start">{item.company_name || "-"}</Td>
                <Td className="text-start">
                  {item.created_at ? dayjs(item.created_at).format("DD/MM/YYYY") : "-"}
                </Td>
                <Td className="text-start">
                  <CommonIconButton
                    type="view"
                    onClick={() => onView && onView(item)}
                  />
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={7} className="text-center font-lato font-medium text-sm leading-[1.5] text-[#1D2939] py-6">
                No matching records found
              </Td>
            </Tr>
          )}
        </TBody>
      </Table>
    </div>
  );
};

export default LearningFeedbackList;
